
const NewError = () => {
    return (
        <>
            <section className="bg-payment-new h-100 bg-white bg-payment-new-error pb-2">
                <div className="top-bar" style={{ paddingBottom: '50px' }}>
                    <div className="d-flex justify-content-center">
                        <img alt="logo" src={require('./../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                    </div>
                    <p className="text-white text-center mb-5 fw-bold">
                        سامانه ملی امن ، سریع و آسان
                    </p>
                </div>
                <div className="container top-container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6 col-12 text-center">
                            <img alt="logo" src={require('./../../assets/media/images/global/reza.webp')} className="profile-img" />
                            <p className="fw-bold mt-3 mb-1">
                                رضا مهوشی
                            </p>
                            <p className="text-muted mb-2">121221212</p>
                            <p className="h5 fw-bold">
                                1,000,000 تومان
                            </p>
                            <span className="badge bg-danger mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                پرداخت ناموفق
                            </span>
                            <div className="px-4">
                                <ul className="list-group list-group-flush mt-4 px-0">
                                    <li className="list-group-item px-0">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                                سایت
                                            </span>
                                            <span className="fw-bold">
                                                ایران تراکنش
                                            </span>
                                        </div>
                                        <hr />
                                    </li>
                                    <li className="list-group-item border px-0">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                                وضعیت پرداخت
                                            </span>
                                            <span className="fw-bold">ناموفق</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <p className="text-center fw-bold mb-0 mt-4" style={{ color: '#FFB72B' }}>
                                توهم ایران تراکنشی شو
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default NewError;